export const DEFAULT_SCOPE = "default";

export const COMPANY_SCOPE = "company";

export const EMPLOYEE_GROUP_SCOPE = "group";
